import {
  LICENSE_SET_LOADING,
  LicenseTypes,
  LicenseState,
} from './License.types';

const defaultState = {
  loading: false,
};

export function licenseReducer(
  state = defaultState,
  action: LicenseTypes,
): LicenseState {
  console.log(action.type);
  switch (action.type) {
    case LICENSE_SET_LOADING: {
      return {
        ...state,
        loading: action.loading,
      };
    }
    default:
      return state;
  }
}
